/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const RecordingIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 32 32"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <rect x="22.2109091" y="11.625" width="4.84969697" height="13.125" />
      <path d="M27.0581818,2.87625 C28.3975758,2.87625 29.4824242,3.995 29.4824242,5.375 L29.4848485,15.375" />
      <path d="M24.6363636,27.25 L24.6363636,30.375" />
      <rect x="22.2109091" y="1.625" width="4.84727273" height="10" />
      <rect x="23.4242424" y="24.75" width="2.42424242" height="2.5" />
      <polyline points="9.71922348 7.25 6.08285985 11 4.26467803 9.125" />
      <polyline points="9.71922348 14.125 6.08285985 17.875 4.26467803 16" />
      <polygon points="12.7495265 27.875 1.84043561 27.875 1.84043561 4.125 18.8101326 4.125 18.8101326 21.625" />
      <polyline points="12.7495265 27.875 12.7495265 21.625 18.8101326 21.625" />
      <path d="M11.5374053,10.375 L15.7798295,10.375" />
      <path d="M11.5374053,16.625 L15.7798295,16.625" />
    </g>
  </svg>
);

export default RecordingIcon;
